/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });

  /*============================================================================
    Custom layout
  ==============================================================================*/
   document.addEventListener("DOMContentLoaded", function () {
    var relatedSlider = document.querySelector('.related-post__grid');
    if (relatedSlider) {
      new FlickityResponsive(relatedSlider, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: true,
        groupCells: 2,
        prevNextButtons: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              groupCells: 1
            }
          }
        ]
      });
    }
  });
  
  /*============================================================================
    Anchor Links
  ==============================================================================*/
  
  let anchorlinks = document.querySelectorAll('a[href^="#"]')

  for (let item of anchorlinks) { 
      item.addEventListener('click', (e)=> {
          let hashval = item.getAttribute('href')
          if (hashval != '#') {
             let target = document.querySelector(hashval)
             let targetPosition = target.getBoundingClientRect().top;
             const offsetPosition = targetPosition - document.querySelector('.header-panel').offsetHeight;
              window.scrollBy({
                 top: offsetPosition,
                 behavior: "smooth"
              });
              history.pushState(null, null, hashval)
          }
         
          e.preventDefault()
      })
  }

  /*============================================================================
    Restaurant filter
  ==============================================================================*/
  document.addEventListener("DOMContentLoaded", function () {
    function initTabs() {
      const $tabs = $('.restaurant-listing .tab-item');
      const $container = $('.grid-container');
      const $items = $('.grid-item');
  
   
        function filterItems(category) {
          const $visibleItems = $items.filter(`[data-category="${category}"]`);
    
          $items.hide().removeClass('active');
          $visibleItems.fadeIn(200).addClass('active');
        }
  
      $tabs.on('click', function (e) {
        e.preventDefault();
  
        const $this = $(this);
        const category = $this.data('category');
  
        $tabs.removeClass('active');
        $this.addClass('active');
  
        filterItems(category);
      });
  
      $tabs.first().trigger('click');
    }
  
    // Run once
    initTabs();
  
    // Run again if Shopify renders this section dynamically (optional)
    document.addEventListener('shopify:section:load', function () {
      initTabs();
    });
  });

  (function($) {
  const $headerSection = $('.header-section');
  const $toolbarSection = $('.toolbar-section');

  $(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop();

    if (scrollTop > 130) {
      // Add sticky class if not already
      if (!$headerSection.hasClass('sticky')) {
        $headerSection.addClass('sticky');
      }

      if (!$toolbarSection.hasClass('sticky')) {
        $toolbarSection.addClass('sticky');
      }

      // Always update toolbarHeight dynamically
      const toolbarHeight = $toolbarSection.innerHeight();
      if (toolbarHeight > 0) {
        $headerSection.css('top', toolbarHeight);
      }
    } else {
      // Remove sticky classes
      $headerSection.removeClass('sticky').css('top', '');
      $toolbarSection.removeClass('sticky');
    }
  });
})(jQuery);

 
    
})();
